import { hasSegmentFlag } from '@/data/flags/local-flags';

/**
 * Provider name constants for integrations.
 * Centralized to prevent routing breakage when provider names change.
 *
 * Each property is a getter that resolves at access time based on the
 * enableIntegrationTileUX segment flag:
 *   - Flag ON  → CDN provider IDs (lowercase, e.g. "slack")
 *   - Flag OFF → Legacy display-style names (e.g. "Slack for Pendo Trends")
 */

const LEGACY_PROVIDER_NAMES = {
    JIRA_FOR_PENDO: 'Jira for Pendo',
    SLACK_FOR_AGENT_ANALYTICS: 'Slack for Agent Analytics',
    SLACK_FOR_PENDO_TRENDS: 'Slack for Pendo Trends',
    SALESFORCE_FOR_LISTEN: 'Salesforce for Listen',
    ZENDESK_FOR_LISTEN: 'Zendesk for Listen',
    GONG_FOR_LISTEN: 'Gong for Listen',
    ZOOM_FOR_LISTEN: 'Zoom for Listen',
    TEAMS_FOR_LISTEN: 'Teams for Listen',
};

/**
 * Unified provider IDs matching CDN provider metadata.
 * Used when the enableIntegrationTileUX segment flag is active.
 */
export const UNIFIED_PROVIDER_NAMES = {
    JIRA_FOR_PENDO: 'jira',
    SLACK_FOR_AGENT_ANALYTICS: 'slack',
    SLACK_FOR_PENDO_TRENDS: 'slack',
    SALESFORCE_FOR_LISTEN: 'salesforce',
    ZENDESK_FOR_LISTEN: 'zendesk',
    GONG_FOR_LISTEN: 'gong',
    ZOOM_FOR_LISTEN: 'zoom',
    TEAMS_FOR_LISTEN: 'microsoft-teams',
};

export const PROVIDER_NAMES = {};

Object.keys(LEGACY_PROVIDER_NAMES).forEach((key) => {
    Object.defineProperty(PROVIDER_NAMES, key, {
        get () {
            return hasSegmentFlag('enableIntegrationTileUX')
                ? UNIFIED_PROVIDER_NAMES[key]
                : LEGACY_PROVIDER_NAMES[key];
        },
        enumerable: true,
    });
});
